import { MaxButton, StatusMaxButton } from "components/view/button";
import { GetAllContentByPrefixResponse } from "lib/worker/api/get_all_content_by_prefix";
import Img from "react-cloudimage-responsive";

export const DisplayApplicationSNAMBET = (
  isLine: String,
  isMobileView: String,
  isIOS: String
) => {
  const openL = () => {
    if (isIOS) {
      window.open(
        `x-web-search://?https://${window.location.hostname}/download_app`
      );
    } else {
      window.open(
        `intent:https://${window.location.hostname}/download_app#Intent;end`
      );
    }
  };

  if (isLine) {
    return (
      <div className="container">
        <br></br>
        {isLine
          ? isMobileView && (
              <>
                <h3>วิธีการดาวน์โหลดแอปพลิเคชัน</h3>
                <div className="center-content col-12">
                  <MaxButton
                    title="เปิด Browser"
                    className="shadow view-glowing margin-bottom-20"
                    status={StatusMaxButton.submit}
                    onClick={openL}
                  ></MaxButton>
                </div>
                {!isIOS && (
                  <div>
                    <div className="row center-content margin-top-20">
                      <div className="view-background col-12 col-md-8">
                        <Img
                          className="full-width-image"
                          src="how-to-snam-line-android-2.png"
                        ></Img>
                      </div>
                    </div>
                    <h4 className="margin-top-20">
                      ขั้นตอนการดาวน์โหลดแอปพลิเคชัน สำหรับ Android
                    </h4>
                    <ul>
                      <li>
                        กดที่ปุ่ม <span>‘เปิด Browser’</span> จะพาท่านไปที่
                        Browser หลักของท่าน ระบบจะแนะนำการดาวน์โหลดแอปพลิเคชัน{" "}
                      </li>
                      <li>
                        สำหรับท่านที่ดาวน์โหลดแอพลิเคชั่น{" "}
                        แล้วจะมีหน้าต่างปรากฏขึ้นมาให้เปิดแอปพลิเคชัน
                      </li>
                    </ul>
                    <div>
                      <div className="row center-content">
                        <div className="view-background col-12 col-md-8">
                          <Img
                            className="full-width-image"
                            src="how-to-snam-android-2.png"
                          ></Img>
                        </div>
                      </div>
                      <h4 className="margin-top-20">
                        ขั้นตอนการเพิ่มหน้าโฮมสำหรับ Android
                      </h4>
                      <ul>
                        <li>กดที่ปุ่มตั้งค่าทางขวาบนในมือถือของท่าน</li>
                        <li>
                          จะมีเมนูปรากฎขึ้นมาเลื่อนไปยัง เพิ่มไปยังหน้าโฮม หรือ
                          ติดตั้งแอปพลิเคชัน
                        </li>
                        <li>
                          จะมีข้อความปรากฎขึ้นมาให้ท่านกดยืนยัน หรือ
                          แอพพลิเคชั่น
                        </li>
                        <li>
                          จะมีหน้าแอปพลิเคชัน ปรากฎบนหน้าโฮมของท่าน
                          ท่านสามารถเล่น ผ่านแอปพลิเคชันได้เลย
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                {isIOS && (
                  <div>
                    <div className="row center-content margin-top-20">
                      <div className="view-background col-12 col-md-8">
                        <Img
                          className="full-width-image"
                          src="how-to-snam-line-ios-2.png"
                        ></Img>
                      </div>
                    </div>
                    <h2 className="margin-top-20">
                      ขั้นตอนการดาวน์โหลดแอปพลิเคชัน สำหรับ IOS
                    </h2>
                    <ul>
                      <li>
                        กดที่ปุ่ม <span>‘เปิด Browser’</span>{" "}
                        ระบบของเราจะพาท่านไปที่ Browser
                        หลักโดยค้นหาหน้าเว็บของเรา ให้ท่านคลิกลิงก์แรก
                        ระบบจะแนะนำการดาวน์โหลดแอปพลิเคชัน{" "}
                      </li>
                    </ul>
                    <div>
                      <div className="row center-content">
                        <div className="view-background col-12 col-md-8">
                          <Img
                            className="full-width-image"
                            src="how-to-snam-ios-2.png"
                          ></Img>
                        </div>
                      </div>
                      <h4 className="margin-top-20">
                        ขั้นตอนการเพิ่มหน้าโฮมสำหรับ iPhone
                      </h4>
                      <ul>
                        <li>กดที่ปุ่มตั้งค่าทางด้านล่างในมือถือของท่าน</li>
                        <li>
                          จะมีเมนูปรากฎขึ้นมาเลื่อนไปยัง เพิ่มไปยังหน้าโฮม หรือ
                          Add To Home Screen
                        </li>
                        <li>
                          จะมีข้อความปรากฎขึ้นมาให้ท่านกดยืนยันเพิ่ม{" "}
                          ไปยังหน้าโฮมของท่าน
                        </li>
                        <li>
                          จะมีหน้าแอปพลิเคชัน ปรากฎบนหน้าโฮมของท่าน
                          ท่านสามารถเล่น ผ่านแอปพลิเคชันได้เลย
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </>
            )
          : null}
      </div>
    );
  } else {
    return (
      <div className="container">
        <br></br>
        <h1 className="center-content">ดาวน์โหลดแอปพลิเคชัน</h1>
        {(!isMobileView ? true : !isIOS) && (
          <div>
            <div className="row center-content">
              <div className="view-background col-12 col-md-8">
                <Img
                  className="full-width-image"
                  src="how-to-snam-android-2.png"
                ></Img>
              </div>
            </div>
            <h2 className="margin-top-20">
              ขั้นตอนการเพิ่มหน้าโฮมสำหรับ Android
            </h2>
            <ul>
              <li>กดที่ปุ่มตั้งค่าทางขวาบนในมือถือของท่าน</li>
              <li>
                จะมีเมนูปรากฎขึ้นมาเลื่อนไปยัง เพิ่มไปยังหน้าโฮม หรือ
                ติดตั้งแอปพลิเคชัน
              </li>
              <li>
                จะมีข้อความปรากฎขึ้นมาให้ท่านกดยืนยัน หรือ ติดตั้งแอปพลิเคชัน
              </li>
              <li>
                จะมีหน้าแอปพลิเคชัน ปรากฎบนหน้าโฮมของท่าน ท่านสามารถเล่น
                ผ่านแอปพลิเคชันได้เลย
              </li>
            </ul>
          </div>
        )}
        {(!isMobileView ? true : isIOS) && (
          <div>
            <div className="row center-content">
              <div className="view-background col-12 col-md-8">
                <Img
                  className="full-width-image"
                  src="how-to-snam-ios-2.png"
                ></Img>
              </div>
            </div>
            <h2 className="margin-top-20">
              ขั้นตอนการเพิ่มหน้าโฮมสำหรับ iPhone
            </h2>
            <ul>
              <li>กดที่ปุ่มตั้งค่าทางด้านล่างในมือถือของท่าน</li>
              <li>
                จะมีเมนูปรากฎขึ้นมาเลื่อนไปยัง เพิ่มไปยังหน้าโฮม หรือ Add To
                Home Screen
              </li>
              <li>
                จะมีข้อความปรากฎขึ้นมาให้ท่านกดยืนยันเพิ่ม ไปยังหน้าโฮมของท่าน
              </li>
              <li>
                จะมีหน้าแอปพลิเคชัน ปรากฎบนหน้าโฮมของท่าน ท่านสามารถเล่น
                ผ่านแอปพลิเคชันได้เลย
              </li>
            </ul>
          </div>
        )}
      </div>
    );
  }
};

export const DisplayApplicationSLOTASIA888 = (
  isLine: String,
  isMobileView: String,
  isIOS: String
) => {
  const openL = () => {
    if (isIOS) {
      window.open(
        `x-web-search://?https://${window.location.hostname}/download_app`
      );
    } else {
      window.open(
        `intent:https://${window.location.hostname}/download_app#Intent;end`
      );
    }
  };

  if (isLine) {
    return (
      <div className="container">
        <br></br>
        {isLine
          ? isMobileView && (
              <>
                <h3>วิธีการดาวน์โหลดแอปพลิเคชัน</h3>
                <div className="center-content col-12">
                  <MaxButton
                    title="เปิด Browser"
                    className="shadow view-glowing margin-bottom-20"
                    status={StatusMaxButton.submit}
                    onClick={openL}
                  ></MaxButton>
                </div>
                {!isIOS && (
                  <div>
                    <div className="row center-content margin-top-20">
                      <div className="view-background col-12 col-md-8">
                        <Img
                          className="full-width-image"
                          src="android-slot.png"
                        ></Img>
                      </div>
                    </div>
                    <h4 className="margin-top-20">
                      ขั้นตอนการดาวน์โหลดแอปพลิเคชัน สำหรับ Android
                    </h4>
                    <ul>
                      <li>
                        กดที่ปุ่ม <span>‘เปิด Browser’</span> จะพาท่านไปที่
                        Browser หลักของท่าน ระบบจะแนะนำการดาวน์โหลดแอปพลิเคชัน{" "}
                      </li>
                      <li>
                        สำหรับท่านที่ดาวน์โหลดแอพลิเคชั่น{" "}
                        แล้วจะมีหน้าต่างปรากฏขึ้นมาให้เปิดแอปพลิเคชัน
                      </li>
                    </ul>
                    <div>
                      <div className="row center-content">
                        <div className="view-background col-12 col-md-8">
                          <Img
                            className="full-width-image"
                            src="android-slot.png"
                          ></Img>
                        </div>
                      </div>
                      <h4 className="margin-top-20">
                        ขั้นตอนการเพิ่มหน้าโฮมสำหรับ Android
                      </h4>
                      <ul>
                        <li>กดที่ปุ่มตั้งค่าทางขวาบนในมือถือของท่าน</li>
                        <li>
                          จะมีเมนูปรากฎขึ้นมาเลื่อนไปยัง เพิ่มไปยังหน้าโฮม หรือ
                          ติดตั้งแอปพลิเคชัน
                        </li>
                        <li>
                          จะมีข้อความปรากฎขึ้นมาให้ท่านกดยืนยัน หรือ
                          แอพพลิเคชั่น
                        </li>
                        <li>
                          จะมีหน้าแอปพลิเคชัน ปรากฎบนหน้าโฮมของท่าน
                          ท่านสามารถเล่น ผ่านแอปพลิเคชันได้เลย
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                {isIOS && (
                  <div>
                    <div className="row center-content margin-top-20">
                      <div className="view-background col-12 col-md-8">
                        <Img
                          className="full-width-image"
                          src="ios-slot.png"
                        ></Img>
                      </div>
                    </div>
                    <h2 className="margin-top-20">
                      ขั้นตอนการดาวน์โหลดแอปพลิเคชัน สำหรับ IOS
                    </h2>
                    <ul>
                      <li>
                        กดที่ปุ่ม <span>‘เปิด Browser’</span>{" "}
                        ระบบของเราจะพาท่านไปที่ Browser
                        หลักโดยค้นหาหน้าเว็บของเรา ให้ท่านคลิกลิงก์แรก
                        ระบบจะแนะนำการดาวน์โหลดแอปพลิเคชัน{" "}
                      </li>
                    </ul>
                    <div>
                      <div className="row center-content">
                        <div className="view-background col-12 col-md-8">
                          <Img
                            className="full-width-image"
                            src="ios-slot.png"
                          ></Img>
                        </div>
                      </div>
                      <h4 className="margin-top-20">
                        ขั้นตอนการเพิ่มหน้าโฮมสำหรับ iPhone
                      </h4>
                      <ul>
                        <li>กดที่ปุ่มตั้งค่าทางด้านล่างในมือถือของท่าน</li>
                        <li>
                          จะมีเมนูปรากฎขึ้นมาเลื่อนไปยัง เพิ่มไปยังหน้าโฮม หรือ
                          Add To Home Screen
                        </li>
                        <li>
                          จะมีข้อความปรากฎขึ้นมาให้ท่านกดยืนยันเพิ่ม{" "}
                          ไปยังหน้าโฮมของท่าน
                        </li>
                        <li>
                          จะมีหน้าแอปพลิเคชัน ปรากฎบนหน้าโฮมของท่าน
                          ท่านสามารถเล่น ผ่านแอปพลิเคชันได้เลย
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </>
            )
          : null}
      </div>
    );
  } else {
    return (
      <div className="container">
        <br></br>
        <h1 className="center-content">ดาวน์โหลดแอปพลิเคชัน</h1>
        {(!isMobileView ? true : !isIOS) && (
          <div>
            <div className="row center-content">
              <div className="view-background col-12 col-md-8">
                <Img className="full-width-image" src="android-slot.png"></Img>
              </div>
            </div>
            <h2 className="margin-top-20">
              ขั้นตอนการเพิ่มหน้าโฮมสำหรับ Android
            </h2>
            <ul>
              <li>กดที่ปุ่มตั้งค่าทางขวาบนในมือถือของท่าน</li>
              <li>
                จะมีเมนูปรากฎขึ้นมาเลื่อนไปยัง เพิ่มไปยังหน้าโฮม หรือ
                ติดตั้งแอปพลิเคชัน
              </li>
              <li>
                จะมีข้อความปรากฎขึ้นมาให้ท่านกดยืนยัน หรือ ติดตั้งแอปพลิเคชัน
              </li>
              <li>
                จะมีหน้าแอปพลิเคชัน ปรากฎบนหน้าโฮมของท่าน ท่านสามารถเล่น
                ผ่านแอปพลิเคชันได้เลย
              </li>
            </ul>
          </div>
        )}
        {(!isMobileView ? true : isIOS) && (
          <div>
            <div className="row center-content">
              <div className="view-background col-12 col-md-8">
                <Img className="full-width-image" src="ios-slot.png"></Img>
              </div>
            </div>
            <h2 className="margin-top-20">
              ขั้นตอนการเพิ่มหน้าโฮมสำหรับ iPhone
            </h2>
            <ul>
              <li>กดที่ปุ่มตั้งค่าทางด้านล่างในมือถือของท่าน</li>
              <li>
                จะมีเมนูปรากฎขึ้นมาเลื่อนไปยัง เพิ่มไปยังหน้าโฮม หรือ Add To
                Home Screen
              </li>
              <li>
                จะมีข้อความปรากฎขึ้นมาให้ท่านกดยืนยันเพิ่ม ไปยังหน้าโฮมของท่าน
              </li>
              <li>
                จะมีหน้าแอปพลิเคชัน ปรากฎบนหน้าโฮมของท่าน ท่านสามารถเล่น
                ผ่านแอปพลิเคชันได้เลย
              </li>
            </ul>
          </div>
        )}
      </div>
    );
  }
};

export const DisplayApplication = (
  isLine: String,
  isMobileView: String,
  isIOS: String,
  content: GetAllContentByPrefixResponse[]
) => {
  const openL = () => {
    if (isIOS) {
      window.open(
        `x-web-search://?https://${window.location.hostname}/download_app`
      );
    } else {
      window.open(
        `intent:https://${window.location.hostname}/download_app#Intent;end`
      );
    }
  };

  const imageIOS = (): GetAllContentByPrefixResponse[] => {
    const s = content.filter((v) => {
      return v.ContentTypeID == 5;
    });
    return s;
  };

  const imageAndoird = (): GetAllContentByPrefixResponse[] => {
    const s = content.filter((v) => {
      return v.ContentTypeID == 6;
    });
    return s;
  };

  if (isLine) {
    return (
      <div className="container">
        <br></br>
        {isLine
          ? isMobileView && (
              <>
                <h3>วิธีการดาวน์โหลดแอปพลิเคชัน</h3>
                <div className="center-content col-12">
                  <MaxButton
                    title="เปิด Browser"
                    className="shadow view-glowing margin-bottom-20"
                    status={StatusMaxButton.submit}
                    onClick={openL}
                  ></MaxButton>
                </div>
                {!isIOS && (
                  <div>
                    {imageAndoird().map((v, i) => {
                      return (
                        <div
                          key={i}
                          className="row center-content margin-top-20"
                        >
                          <div className="view-background col-12 col-md-8">
                            <Img
                              className="full-width-image"
                              src={v.Html ?? ""}
                            ></Img>
                          </div>
                        </div>
                      );
                    })}

                    <h4 className="margin-top-20">
                      ขั้นตอนการดาวน์โหลดแอปพลิเคชัน สำหรับ Android
                    </h4>
                    <ul>
                      <li>
                        กดที่ปุ่ม <span>เปิด Browser</span> จะพาท่านไปที่
                        Browser หลักของท่าน ระบบจะแนะนำการดาวน์โหลดแอปพลิเคชัน{" "}
                      </li>
                      <li>
                        สำหรับท่านที่ดาวน์โหลดแอพลิเคชั่น{" "}
                        แล้วจะมีหน้าต่างปรากฏขึ้นมาให้เปิดแอปพลิเคชัน
                      </li>
                    </ul>
                    <div>
                      {imageAndoird().map((v, i) => {
                        return (
                          <div className="row center-content" key={i}>
                            <div className="view-background col-12 col-md-8">
                              <Img
                                className="full-width-image"
                                src={v.Html ?? ""}
                              ></Img>
                            </div>
                          </div>
                        );
                      })}
                      <h4 className="margin-top-20">
                        ขั้นตอนการเพิ่มหน้าโฮมสำหรับ Android
                      </h4>
                      <ul>
                        <li>กดที่ปุ่มตั้งค่าทางขวาบนในมือถือของท่าน</li>
                        <li>
                          จะมีเมนูปรากฎขึ้นมาเลื่อนไปยัง เพิ่มไปยังหน้าโฮม หรือ
                          ติดตั้งแอปพลิเคชัน
                        </li>
                        <li>
                          จะมีข้อความปรากฎขึ้นมาให้ท่านกดยืนยัน หรือ
                          แอพพลิเคชั่น
                        </li>
                        <li>
                          จะมีหน้าแอปพลิเคชัน ปรากฎบนหน้าโฮมของท่าน
                          ท่านสามารถเล่น ผ่านแอปพลิเคชันได้เลย
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
                {isIOS && (
                  <div>
                    {imageIOS().map((v, i) => {
                      return (
                        <div
                          key={i}
                          className="row center-content margin-top-20"
                        >
                          <div className="view-background col-12 col-md-8">
                            <Img
                              className="full-width-image"
                              src={v.Html ?? ""}
                            ></Img>
                          </div>
                        </div>
                      );
                    })}

                    <h2 className="margin-top-20">
                      ขั้นตอนการดาวน์โหลดแอปพลิเคชัน สำหรับ IOS
                    </h2>
                    <ul>
                      <li>
                        กดที่ปุ่ม <span>‘เปิด Browser’</span>{" "}
                        ระบบของเราจะพาท่านไปที่ Browser
                        หลักโดยค้นหาหน้าเว็บของเรา ให้ท่านคลิกลิงก์แรก
                        ระบบจะแนะนำการดาวน์โหลดแอปพลิเคชัน{" "}
                      </li>
                    </ul>
                    <div>
                      <div className="row center-content">
                        <div className="view-background col-12 col-md-8">
                          <Img
                            className="full-width-image"
                            src="ios-slot.png"
                          ></Img>
                        </div>
                      </div>
                      <h4 className="margin-top-20">
                        ขั้นตอนการเพิ่มหน้าโฮมสำหรับ iPhone
                      </h4>
                      <ul>
                        <li>กดที่ปุ่มตั้งค่าทางด้านล่างในมือถือของท่าน</li>
                        <li>
                          จะมีเมนูปรากฎขึ้นมาเลื่อนไปยัง เพิ่มไปยังหน้าโฮม หรือ
                          Add To Home Screen
                        </li>
                        <li>
                          จะมีข้อความปรากฎขึ้นมาให้ท่านกดยืนยันเพิ่ม{" "}
                          ไปยังหน้าโฮมของท่าน
                        </li>
                        <li>
                          จะมีหน้าแอปพลิเคชัน ปรากฎบนหน้าโฮมของท่าน
                          ท่านสามารถเล่น ผ่านแอปพลิเคชันได้เลย
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </>
            )
          : null}
      </div>
    );
  } else {
    return (
      <div className="container">
        <br></br>
        <h1 className="center-content">ดาวน์โหลดแอปพลิเคชัน</h1>
        {(!isMobileView ? true : !isIOS) && (
          <div>
            {imageAndoird().map((v, i) => {
              return (
                <div className="row center-content" key={i}>
                  <div className="view-background col-12 col-md-8">
                    <Img className="full-width-image" src={v.Html ?? ""}></Img>
                  </div>
                </div>
              );
            })}
            <h2 className="margin-top-20">
              ขั้นตอนการเพิ่มหน้าโฮมสำหรับ Android
            </h2>
            <ul>
              <li>กดที่ปุ่มตั้งค่าทางขวาบนในมือถือของท่าน</li>
              <li>
                จะมีเมนูปรากฎขึ้นมาเลื่อนไปยัง เพิ่มไปยังหน้าโฮม หรือ
                ติดตั้งแอปพลิเคชัน
              </li>
              <li>
                จะมีข้อความปรากฎขึ้นมาให้ท่านกดยืนยัน หรือ ติดตั้งแอปพลิเคชัน
              </li>
              <li>
                จะมีหน้าแอปพลิเคชัน ปรากฎบนหน้าโฮมของท่าน ท่านสามารถเล่น
                ผ่านแอปพลิเคชันได้เลย
              </li>
            </ul>
          </div>
        )}
        {(!isMobileView ? true : isIOS) && (
          <div>
            {imageIOS().map((v, i) => {
              return (
                <div className="row center-content" key={i}>
                  <div className="view-background col-12 col-md-8">
                    <Img className="full-width-image" src={v.Html ?? ""}></Img>
                  </div>
                </div>
              );
            })}

            <h2 className="margin-top-20">
              ขั้นตอนการเพิ่มหน้าโฮมสำหรับ iPhone
            </h2>
            <ul>
              <li>กดที่ปุ่มตั้งค่าทางด้านล่างในมือถือของท่าน</li>
              <li>
                จะมีเมนูปรากฎขึ้นมาเลื่อนไปยัง เพิ่มไปยังหน้าโฮม หรือ Add To
                Home Screen
              </li>
              <li>
                จะมีข้อความปรากฎขึ้นมาให้ท่านกดยืนยันเพิ่ม ไปยังหน้าโฮมของท่าน
              </li>
              <li>
                จะมีหน้าแอปพลิเคชัน ปรากฎบนหน้าโฮมของท่าน ท่านสามารถเล่น
                ผ่านแอปพลิเคชันได้เลย
              </li>
            </ul>
          </div>
        )}
      </div>
    );
  }
};
